import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { getDuration } from '@delmonicos/shared-sdk/libs/cpms/src/clients/utils/formatters/get-duration';
import { GatewayChargingSessionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/charging-sessions/gateway-charging-session.model';
import { CellContext } from '@tanstack/react-table';

interface EmspBoChargingSessionListDurationCellProps
  extends CellContext<GatewayChargingSessionModel, unknown> {}

export const EmspBoChargingSessionListDurationCell = ({
  row,
}: EmspBoChargingSessionListDurationCellProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  // Nothing to do

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Text truncate>
      {getDuration(row.original.startedAt, row.original.stoppedAt)}
    </Text>
  );
};
